<template>
  <div>
    <b-btn @click="back" class="btn-lg mb-4 rounded-0" block variant="warning">
      <div v-if="!newUser" class="arrow-left"><i class="left"></i></div>
      <span v-if="!newUser">Назад</span> &nbsp;
    </b-btn>

    <div v-if="!viewDataUpdated || !user" class="my-2">
      <div class="d-flex justify-content-center">
        <div class="spinner-border" role="status">
          <span class="sr-only">Загружается...</span>
        </div>
      </div>
    </div>
    <div v-else>
      <!-- ------------------------------------------------------ -->
      <div v-if="loginExpired" class="mb-4">
        <b-card-body class="m-2">
          <b-btn class="w-75" variant="danger">
            Ссылка устарела<br>повторите регистрацию
          </b-btn>
        </b-card-body>
        <hr>
      </div>
      <!-- ------------------------------------------------------ -->
      <div v-if="!user.auth" class="my-2">
        <div v-if="wentFromGame" class="mb-4">
          <b-card-body class="m-2 size-4 warningText">
            Для продолжения необходимо зарегистрироваться
          </b-card-body>
        </div>
        <RegisterByTG v-if="user.userConfirmation == 'telegram'"/>
        <RegisterBySms v-else-if="user.userConfirmation == 'sms'"/>
      </div>
      <!-- ------------------------------------------------------ -->
      <div v-else-if="wantChange || newUser" class="my-2">
        <b-btn class="p-2 rounded-0" block variant="secondary">
            Фамилия и имя
        </b-btn>
        <b-form @submit="changeName" class="mt-3" >
          <b-form-group id="userName"
                        label-for="userName"
                        class="description mx-4 my-2"
                        description="Необходимо для прохода на площадку">
            <b-form-input id="userName"
                          type="text"
                          class="userName"
                          v-model="newName"
                          required
                          placeholder="Фамилия и имя">
            </b-form-input>
          </b-form-group>
          <b-btn class="mx-4 my-2 w-75" type="submit" variant="primary">Сохранить</b-btn>
        </b-form>
      </div>
      <!-- ------------------------------------------------------ -->
      <div v-else>
        <b-card no-body class="mb-1">
          <b-btn class="p-2 rounded-0" block v-b-toggle.regStep2 variant="secondary">
            Личные данные
          </b-btn>
          <b-card-body>
            <h5>{{ user.name }}</h5>
            <h5>{{ user.phone }}</h5>
          </b-card-body>
        </b-card>

        <div class="mt-3">
          <b-btn class="mx-4 my-2 w-75" @click="changeProfile" variant="primary">Изменить</b-btn>
          <b-btn class="mx-4 my-2 w-75" @click="exit" variant="danger">Выйти</b-btn>
        </div>
      </div>
      <!-- ------------------------------------------------------ -->
    </div>

    <div>
      <b-modal id="err-change" title="Ошибка" ok-variant="danger" ok-title="ОК" cancel-variant="hidden">
        <h5 class="my-4 text">Не удалось сохранить изменения. Проверьте доступность интернета</h5>
      </b-modal>
    </div>
  </div>
</template>

<script>

import RegisterBySms from './RegisterBySms.vue'
import RegisterByTG from './RegisterByTG.vue'

export default {
  name: 'Profile',
  components: {
    RegisterBySms,
    RegisterByTG
  },
  data: function() {
    return  {
      wantChange: false,
      newName: '',
    }
  },
  mounted: function () {
    if(this.$route.query.ac) {
      this.$store.commit('setAuthCode', this.$route.query.ac + '/true') // wentByAuthLink
      this.$router.replace({
        query: {},
      })
      return;
    }

    this.$store.dispatch('getUserInfo', {})
  },
  computed: {
    user () {
      return this.$store.state.user
    },
    wentFromGame: function () {
      return this.$router.currentRoute.query.welcome
    },
    newUser: function () {
      return this.$store.state.user && this.$store.state.user.name === ''
    },
    viewDataUpdated () {
      return this.$store.state.viewDataUpdated
    },
    loginExpired () {
      return this.$route.query.expired || (this.user && this.user.authLinkExpired)
    },
  },
  methods: {
    changeProfile: function () {
      this.newName = this.user && this.user.name
      this.wantChange = true
    },
    changeName: function (evt) {
      evt.preventDefault()

      this.$store.dispatch('setUserName', this.newName)
      .then(res => {
        if (!res || !res.ok) {
          this.$bvModal.show('err-change')
        } else if (this.$router.currentRoute.query.retUrl) {
          this.$router.push(this.$router.currentRoute.query.retUrl)
        } else {
          this.wantChange = false
          this.back()
        }
      })
    },
    exit: function () {
      this.$store.dispatch('exitUser').then(this.back)
    },
    back: function() {
      if (this.newUser) {
        return
      }
      if (this.wantChange) {
        this.wantChange = false
        return
      }
      if (this.$route.path.includes('/login')) {
        this.$router.push({
          path: '/',
        })
        return
      }

      this.$router.back()
    },
  },
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.userName {
  font-size: 20px;
}

.warningText {
  font-size: 18px;
}

.warningColor {
  background-color: red;
}
</style>

<style>
@import '../assets/backarrow.css';
</style>
